import { LoginMethod, UserRole } from '@mi-front/core';
import { defineMessage, defineMessages, MessageDescriptor } from 'react-intl';

/**
 * Field label for the login method form field.
 */
export const loginMethodFieldLabel = defineMessage({
  id: 'admin.users.loginMethod.label',
  defaultMessage: 'Método de login',
});

/**
 * Login method labels (SOCIAL_LOGIN, USERNAME_PASSWORD).
 * Use with formatMessage so the extractor picks up the ids and defaultMessages.
 */
export const loginMethodLabelMessages: Record<LoginMethod, MessageDescriptor> = defineMessages({
  [LoginMethod.SOCIAL_LOGIN]: {
    id: 'admin.users.loginMethod.SOCIAL_LOGIN.label',
    defaultMessage: 'Login con Google',
  },
  [LoginMethod.USERNAME_PASSWORD]: {
    id: 'admin.users.loginMethod.USERNAME_PASSWORD.label',
    defaultMessage: 'Usuario y contraseña',
  },
});

/**
 * Login method option descriptions (SOCIAL_LOGIN, USERNAME_PASSWORD).
 * Use with formatMessage so the extractor picks up the ids and defaultMessages.
 */
export const loginMethodDescriptionMessages: Record<LoginMethod, MessageDescriptor> =
  defineMessages({
    [LoginMethod.SOCIAL_LOGIN]: {
      id: 'admin.users.loginMethod.SOCIAL_LOGIN.description',
      defaultMessage: 'El usuario utilizará su cuenta de Google existente para iniciar sesión.',
    },
    [LoginMethod.USERNAME_PASSWORD]: {
      id: 'admin.users.loginMethod.USERNAME_PASSWORD.description',
      defaultMessage: 'El usuario recibirá un email con instrucciones para configurar su cuenta.',
    },
  });

/**
 * User role labels (CLIENT_USER, CLIENT_ADMIN, SUPERADMIN).
 * Use with formatMessage so the extractor picks up the ids and defaultMessages.
 */
export const userRoleLabelMessages: Record<UserRole, MessageDescriptor> = defineMessages({
  [UserRole.CLIENT_ADMIN]: {
    id: 'admin.users.roles.values.CLIENT_ADMIN.label',
    defaultMessage: 'Administrador',
  },
  [UserRole.CLIENT_USER]: {
    id: 'admin.users.roles.values.CLIENT_USER.label',
    defaultMessage: 'Básico',
  },
  [UserRole.SUPERADMIN]: {
    id: 'admin.users.roles.values.SUPERADMIN.label',
    defaultMessage: 'Superadministrador',
  },
});

/**
 * User role descriptions (CLIENT_USER, CLIENT_ADMIN, SUPERADMIN).
 * Use with formatMessage so the extractor picks up the ids and defaultMessages.
 */
export const userRoleDescriptionMessages: Record<UserRole, MessageDescriptor> = defineMessages({
  [UserRole.CLIENT_ADMIN]: {
    id: 'admin.users.roles.values.CLIENT_ADMIN.description',
    defaultMessage: 'Usuario administrador del cliente',
  },
  [UserRole.CLIENT_USER]: {
    id: 'admin.users.roles.values.CLIENT_USER.description',
    defaultMessage: 'Usuario estándar del cliente',
  },
  [UserRole.SUPERADMIN]: {
    id: 'admin.users.roles.values.SUPERADMIN.description',
    defaultMessage: 'Administrador del sistema',
  },
});
